// extracted by mini-css-extract-plugin
export var filterIncDec = "_f7-0";
export var leftBorder = "_f7-1";
export var rightBorder = "_f7-2";
export var stringInput = "_f7-3";